import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from "./user-management.reducer"
import {AppState} from "../../../reducers";

export const currentState = (state: AppState) => (state[fromReducer.userManagementsFeatureKey])

export const selectUserManagements = createSelector(currentState, fromReducer.selectAll)

export const selectSystemAdministrators = createSelector(selectUserManagements, (systenAdminstrators) => {
  return systenAdminstrators.map(admin => {
    return {
      ...admin,
      modDesignation: admin?.userDesignation?.designationName,
      modRole: admin?.role?.roleName,
      fullName: `${admin?.profileTitle} ${admin?.userFirstName} ${admin?.userLastName}`,
      active: admin?.profileIsDeactivated ? "No" : "Yes"
    }
  })
})
